
import { Component, Prop, Vue } from 'vue-property-decorator';
import api from '@/api';
import Swal from 'sweetalert2';
import { Route } from 'vue-router';
import adBlockType from '@/enums/adBlockType';
import ItemForm from './Form.vue';

const { appAd } = api;

@Component({
  components: { ItemForm },
})
export default class AppAdvertisementCreate extends Vue {
  private loading: boolean = false;

  private blockType: adBlockType = adBlockType.None;

  private get getTitle() {
    return this.blockType === adBlockType.Popup ? '新增首頁彈窗廣告' : '新增首頁廣告版位';
  }

  private async submit(form: any) {
    if (form) {
      this.loading = true;
      const { status } = await appAd.create(form, this.blockType);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '新增成功' });
        await this.$router.back();
      }
    }
  }

  private setBlockType(type: any) {
    this.blockType = type;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: AppAdvertisementCreate) => void) => void,
  ) {
    const blockType = to.name === 'appAdPopupCreate' ? adBlockType.Popup : adBlockType.Carousel;
    await next(async (vm) => {
      vm.setBlockType(blockType);
    });
  }
}
